// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const INIT_COGNITO_AUTH_SESSION = 'INIT_COGNITO_AUTH_SESSION';
export const RESET_AUTH_STORE = 'RESET_AUTH_STORE'
export const SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE';
export const CREATE_COGNITO_USER = 'CREATE_COGNITO_USER';
export const VERIFY_COGNITO_USER = 'VERIFY_COGNITO_USER';
export const SIGNUP_COGNIO_USER_SUCCESS = 'SIGNUP_COGNIO_USER_SUCCESS';
export const SIGN_IN_COGNITO_USER = 'SIGN_IN_COGNITO_USER';
export const VERIFY_COGNITO_OTP = 'VERIFY_COGNITO_OTP';
export const SIGN_IN_COGNITO_USER_SUCCESS = 'SIGN_IN_COGNITO_USER_SUCCESS';
export const PUT_COGNITO_USER = 'PUT_COGNITO_USER';
export const ACCEPT_OTP = 'ACCEPT_OTP';

export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';

//Sticky
export const GET_STICKY = 'GET_STICKY';
export const NOTES_UPDATE='NOTES_UPDATE';
export const FETCH_ALL_NOTES_SUCCESS='FETCH_ALL_NOTES_SUCCESS';
export const UPDATE_ALL_NOTES_SUCCESS='UPDATE_ALL_NOTES_SUCCESS';

//Contact
export const GET_All_CONTACT_SUCCESS = 'GET_All_CONTACT_SUCCESS';
export const ON_ADD_CONTACT_SUCCESS = 'ON_ADD_CONTACT_SUCCESS';
export const UPDATE_CONTACT_SUCCESS='UPDATE_CONTACT_SUCCESS';
export const DELETE_CONTACT_SUCCESS='DELETE_CONTACT_SUCCESS';

// Dashboard
export const GET_STUDENT_SESSIONS = 'GET_STUDENT_SESSIONS';
export const GET_TEACHER_DETAILS = 'GET_TEACHER_DETAILS';

export const GET_RECENT_ASSIGNMENT_SUCCESS = 'GET_RECENT_ASSIGNMENT_SUCCESS';
export const GET_RECENT_ASSIGNMENT_FAILED = 'GET_RECENT_ASSIGNMENT_FAILED';

export const GET_STUDENT_SESSIONS_SUCCESS = 'GET_STUDENT_SESSIONS_SUCCESS';
export const GET_TEACHER_DETAILS_SUCCESS = 'GET_TEACHER_DETAILS_SUCCESS';
export const GET_STUDENT_SESSIONS_FAILED = 'GET_STUDENT_SESSIONS_FAILED';
export const GET_TEACHER_DETAILS_FAILED = 'GET_TEACHER_DETAILS_FAILED';
export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS'

export const GET_STUDENT_PRACTICE_SESSIONS = 'GET_STUDENT_PRACTICE_SESSIONS'
export const GET_STUDENT_CHALLENGE_SESSIONS = 'GET_STUDENT_CHALLENGE_SESSIONS'
export const GET_STUDENT_CHAPTER_PROGRESS ='GET_STUDENT_CHAPTER_PROGRESS'

export const GET_CLASS_ASSIGNMENT_SESSION = 'GET_CLASS_ASSIGNMENT_SESSION'
export const GET_CLASS_ASSIGNMENT_SESSION_SUCCESS = 'GET_CLASS_ASSIGNMENT_SESSION_SUCCESS'
export const GET_CLASS_ASSIGNMENT_SESSION_FAILED = 'GET_CLASS_ASSIGNMENT_SESSION_FAILED'

export const GET_LEADERBOARD = 'GET_LEADERBOARD'
export const GET_LEADERBOARD_SUCCESS = 'GET_LEADERBOARD_SUCCESS'
export const GET_LEADERBOARD_FAILED = 'GET_LEADERBOARD_FAILED'

export const GET_CLASS_PROGRESS = 'GET_CLASS_PROGRESS'
export const GET_CLASS_PROGRESS_SUCCESS = 'GET_CHAPTER_PROGRESS_SUCCESS'
export const GET_CLASS_PROGRESS_FAILED = 'GET_CHAPTER_PROGRESS_FAILED'